import { render, staticRenderFns } from "./CertificateOfService.vue?vue&type=template&id=7bbbda23"
import script from "./CertificateOfService.vue?vue&type=script&lang=ts"
export * from "./CertificateOfService.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports